import React from "react";
import Modal from "./Modal";

const RefundPolicy = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Refund & Cancellation Policy">
            <div className="max-w-3xl mx-auto p-6 text-gray-800 text-left">
                {/* <h1 className="text-3xl font-bold mb-4">Billing & Subscription Policy</h1> */}
                <p className="mb-4">
                    We believe in transparency when it comes to billing, subscriptions, and refunds.
                </p>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">1. No Refund Policy</h2>
                    <ul className="list-disc pl-5">
                        <li>Once a subscription payment is made, it is non-refundable.</li>
                        <li>You can cancel anytime before your next billing cycle to avoid charges.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">2. How to Cancel</h2>
                    <ul className="list-disc pl-5">
                        <li>Go to your Stripe account dashboard.  <button
                            onClick={() => window.open("https://billing.stripe.com/p/login/eVa17Ff248zAcj64gg", "_blank")}
                            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded"
                        >
                            Subscription
                        </button></li>
                        <li>Follow the instructions to cancel your SoftEstimate subscription.</li>
                        <li>You will continue to have access until the end of your billing cycle.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">3. Subscription Pricing & Changes</h2>
                    <ul className="list-disc pl-5">
                        <li><strong>Current pricing:</strong> $2.99/month for Individual & $4.99/month for Business (Limited Offer).</li>
                        <li><strong>Regular pricing:</strong> $12.00/month for Individual & $24.99/month for Business (effective after June).</li>
                        <li>Subscription rates may change, and we will notify users in advance.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">4. Billing Issues & Support</h2>
                    <ul className="list-disc pl-5">
                        <li>If you experience billing issues, please contact Stripe support directly.</li>
                        <li>For any questions, reach out to
                            <a href="mailto:admin@softestimate.com" className="text-blue-600 underline ml-1">
                                admin@softestimate.com
                            </a>.
                        </li>
                    </ul>
                </section>
            </div>
        </Modal>
    );
};

export default RefundPolicy;
